<router-outlet></router-outlet>
<app-toast></app-toast>
<app-voice-assistant *ngIf="uiStore.isGlobalMicActive()"></app-voice-assistant>
<app-quota-upgrade-modal 
    [show]="quotaService.showModal()" 
    [message]="quotaService.modalMessage()"
    (close)="quotaService.closeModal()">
</app-quota-upgrade-modal>
<app-pipeline-loader-popup></app-pipeline-loader-popup>
<app-jivu-command-handoff-dialog></app-jivu-command-handoff-dialog>
<app-render-loader></app-render-loader>
<app-dirty-changes-dialog></app-dirty-changes-dialog>
<app-local-ai-download-overlay></app-local-ai-download-overlay>

<section
  *ngIf="showMandatoryNativeUpdate()"
  class="mandatory-update-backdrop"
  role="dialog"
  aria-modal="true"
  aria-labelledby="mandatory-update-title"
>
  <div class="mandatory-update-panel">
    <span class="mandatory-update-icon" aria-hidden="true">
      <i class="fas fa-download"></i>
    </span>
    <p class="mandatory-update-eyebrow">Update required</p>
    <h1 id="mandatory-update-title">Install the latest HeyJivu app</h1>
    <p *ngIf="!appUpdate.updateError()">
      {{ appUpdate.updateMessage() || ('Version ' + appUpdate.latestVersion() + ' is required before you continue. Your account and saved work will stay available after the update.') }}
    </p>
    <p class="mandatory-update-error" *ngIf="appUpdate.updateError()">{{ appUpdate.updateError() }}</p>
    <div class="mandatory-update-progress" *ngIf="appUpdate.updatePhase() === 'downloading'" aria-label="Update download progress">
      <span [style.width.%]="appUpdate.downloadProgress()"></span>
    </div>
    <button type="button" (click)="appUpdate.applyUpdate()" [disabled]="appUpdate.isUpdating()">
      <i class="fas fa-download" aria-hidden="true"></i>
      <span>{{ appUpdate.updateActionLabel() }}</span>
    </button>
    <small>Installed version {{ appUpdate.currentVersion() }}</small>
  </div>
</section>
